import icon from "images/icons/icon-filter.svg?raw"
import parse from "html-react-parser"

interface Props {
  title: string
}

export default function FilterIcon({ title }: Props) {
  return <span className="svg-icon" title={title}>{parse(icon)}</span>
}
